// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Nx4Y","mobile":"Pzojf","listGeneralTitle":"_1gEaK"};